// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RoomItem_room__item__bmEq- {
	display: flex;
	gap: 2rem;
}

.RoomItem_room__item__column__zrvJj {
	display: flex;
	flex-direction: column;
	width: calc(50% - 1.88rem);
	gap: 2rem;
}

.RoomItem_room__item__column__zrvJj .RoomItem_services__items__Lu01d {
	height: 10rem;
}

.RoomItem_room__item__bmEq- img,
.RoomItem_room__item__column__zrvJj img {
	cursor: pointer;
}

.RoomItem_info__block__KVhXn {
	width: 100%;
	display: flex;
	flex-direction: column;
	gap: 1.5rem;
}

.RoomItem_info__header__nxZJe {
	display: flex;
	justify-content: space-between;
	width: 100%;
}

.RoomItem_room__name__ctW-D {
	color: var(--accent-color, #956446);

	/* H3 */
	font-family: 'Noto Sans';
	font-size: 1.625rem;
	font-style: normal;
	font-weight: 500;
	line-height: 150%; /* 2.4375rem */
}

.RoomItem_room__persons__iO6d6 {
	display: flex;
	align-items: center;
	gap: 1rem;

	color: var(--accent-color, #956446);

	/* text small */
	font-family: 'Noto Sans';
	font-size: 1rem;
	font-style: normal;
	font-weight: 400;
	line-height: 160%; /* 1.6rem */
}

.RoomItem_info__text__g5zMs {
	width: 100%;
	color: var(--accent-color, #956446);

	/* text small */
	font-family: 'Noto Sans';
	font-size: 1rem;
	font-style: normal;
	font-weight: 400;
	line-height: 160%; /* 1.6rem */
	height: 3rem;
}

.RoomItem_info__services__pGA3F {
	color: var(--accent-color, #956446);

	/* text small bold */
	font-family: 'Noto Sans';
	font-size: 1rem;
	font-style: normal;
	font-weight: 700;
	line-height: 160%; /* 1.6rem */

	display: flex;
	flex-direction: column;
	gap: 1rem;
}

.RoomItem_services__items__Lu01d {
	display: flex;
	flex-direction: column;

	gap: 0.5rem;
}

.RoomItem_service__item__-mpJv {
	display: flex;
	align-items: center;
	gap: 0.65rem;

	/* text small */
	font-family: 'Noto Sans';
	font-size: 1rem;
	font-style: normal;
	font-weight: 400;
	line-height: 160%; /* 1.6rem */
}
.RoomItem_service__item__-mpJv svg {
	width: 1.5625rem;
	height: 1.5625rem;
}

.RoomItem_info__footer__sU60I {
	margin-top: 2rem;
	width: 100%;
	border-top: 1px solid var(--accent-color);
	display: flex;
	flex-direction: column;
	gap: 1.25rem;
}

.RoomItem_info__price__wRkhh {
	margin-top: 1.25rem;
	display: flex;
	justify-content: space-between;

	color: var(--accent-color, #956446);
	font-size: 1rem;
	font-style: normal;
	font-weight: 600;
	line-height: 160%; /* 1.6rem */
}

.RoomItem_footer__buttons__T2j4c {
	display: flex;
	gap: 1.25rem;
}

.RoomItem_primary__btn__2hhw7 {
	width: 13.4375rem;
	height: 3.125rem;
	flex-shrink: 0;
	border-radius: 0.5rem;
	background: var(--accent-color, #956446);

	/* btn */
	box-shadow: -2px 4px 5px 0px rgba(148, 93, 60, 0.06);

	color: var(--text-color, #fff);

	display: flex;
	align-items: center;
	justify-content: center;

	/* text small semibold */
	font-family: 'Noto Sans';
	font-size: 1rem;
	font-style: normal;
	font-weight: 600;
	line-height: 160%; /* 1.6rem */

	cursor: pointer;
}

.RoomItem_secondary__btn__cEmVe {
	width: 13.4375rem;
	height: 3.125rem;
	flex-shrink: 0;

	border-radius: 0.5rem;
	border: 1px solid var(--accent-color, #956446);
	background: var(--text-color, #fff);

	/* btn light */
	box-shadow: -2px 4px 5px -4px rgba(109, 95, 85, 0.08);

	color: var(--accent-color, #956446);

	/* text small semibold */
	font-family: 'Noto Sans';
	font-size: 1rem;
	font-style: normal;
	font-weight: 600;
	line-height: 160%; /* 1.6rem */

	cursor: pointer;
}

@media (max-width: 460px) {
	.RoomItem_room__item__bmEq- {
		flex-direction: column;
		align-items: center;
		box-sizing: border-box;
		width: 100%;
	}

	.RoomItem_room__item__column__zrvJj {
		flex-direction: column;
		align-items: center;
		box-sizing: border-box;
		width: 100%;
	}

	.RoomItem_room__item__bmEq- img {
		width: 100%;
	}

	.RoomItem_info__text__g5zMs {
		height: auto;
	}

	.RoomItem_info__block__KVhXn {
		height: auto;
		width: 100%;
	}
	.RoomItem_room__name__ctW-D {
		font-size: 1.5rem;
		font-style: normal;
		font-weight: 500;
		line-height: 130%; /* 1.95rem */
	}

	.RoomItem_room__persons__iO6d6 {
		font-size: 0.9375rem;
		font-style: normal;
		font-weight: 400;
		line-height: 160%; /* 1.5rem */
		gap: 0.3rem;
		width: 10rem;
		justify-content: flex-end;
	}
	.RoomItem_footer__buttons__T2j4c {
		flex-direction: column;
		gap: 0.6rem;
	}
	.RoomItem_primary__btn__2hhw7 {
		width: 100%;
	}
	.RoomItem_secondary__btn__cEmVe {
		width: 100%;
	}
}

@media (max-width: 360px) {
	.RoomItem_room__persons__iO6d6 {
		width: 12rem;
	}
}
`, "",{"version":3,"sources":["webpack://./src/Components/DefaultPage/Rooms/RoomItem/RoomItem.module.css"],"names":[],"mappings":"AAAA;CACC,aAAa;CACb,SAAS;AACV;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,0BAA0B;CAC1B,SAAS;AACV;;AAEA;CACC,aAAa;AACd;;AAEA;;CAEC,eAAe;AAChB;;AAEA;CACC,WAAW;CACX,aAAa;CACb,sBAAsB;CACtB,WAAW;AACZ;;AAEA;CACC,aAAa;CACb,8BAA8B;CAC9B,WAAW;AACZ;;AAEA;CACC,mCAAmC;;CAEnC,OAAO;CACP,wBAAwB;CACxB,mBAAmB;CACnB,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB,EAAE,cAAc;AAClC;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,SAAS;;CAET,mCAAmC;;CAEnC,eAAe;CACf,wBAAwB;CACxB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB,EAAE,WAAW;AAC/B;;AAEA;CACC,WAAW;CACX,mCAAmC;;CAEnC,eAAe;CACf,wBAAwB;CACxB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB,EAAE,WAAW;CAC9B,YAAY;AACb;;AAEA;CACC,mCAAmC;;CAEnC,oBAAoB;CACpB,wBAAwB;CACxB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB,EAAE,WAAW;;CAE9B,aAAa;CACb,sBAAsB;CACtB,SAAS;AACV;;AAEA;CACC,aAAa;CACb,sBAAsB;;CAEtB,WAAW;AACZ;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,YAAY;;CAEZ,eAAe;CACf,wBAAwB;CACxB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB,EAAE,WAAW;AAC/B;AACA;CACC,gBAAgB;CAChB,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;CAChB,WAAW;CACX,yCAAyC;CACzC,aAAa;CACb,sBAAsB;CACtB,YAAY;AACb;;AAEA;CACC,mBAAmB;CACnB,aAAa;CACb,8BAA8B;;CAE9B,mCAAmC;CACnC,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB,EAAE,WAAW;AAC/B;;AAEA;CACC,aAAa;CACb,YAAY;AACb;;AAEA;CACC,iBAAiB;CACjB,gBAAgB;CAChB,cAAc;CACd,qBAAqB;CACrB,wCAAwC;;CAExC,QAAQ;CACR,oDAAoD;;CAEpD,8BAA8B;;CAE9B,aAAa;CACb,mBAAmB;CACnB,uBAAuB;;CAEvB,wBAAwB;CACxB,wBAAwB;CACxB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB,EAAE,WAAW;;CAE9B,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,gBAAgB;CAChB,cAAc;;CAEd,qBAAqB;CACrB,8CAA8C;CAC9C,mCAAmC;;CAEnC,cAAc;CACd,qDAAqD;;CAErD,mCAAmC;;CAEnC,wBAAwB;CACxB,wBAAwB;CACxB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB,EAAE,WAAW;;CAE9B,eAAe;AAChB;;AAEA;CACC;EACC,sBAAsB;EACtB,mBAAmB;EACnB,sBAAsB;EACtB,WAAW;CACZ;;CAEA;EACC,sBAAsB;EACtB,mBAAmB;EACnB,sBAAsB;EACtB,WAAW;CACZ;;CAEA;EACC,WAAW;CACZ;;CAEA;EACC,YAAY;CACb;;CAEA;EACC,YAAY;EACZ,WAAW;CACZ;CACA;EACC,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,YAAY;CAChC;;CAEA;EACC,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,WAAW;EAC9B,WAAW;EACX,YAAY;EACZ,yBAAyB;CAC1B;CACA;EACC,sBAAsB;EACtB,WAAW;CACZ;CACA;EACC,WAAW;CACZ;CACA;EACC,WAAW;CACZ;AACD;;AAEA;CACC;EACC,YAAY;CACb;AACD","sourcesContent":[".room__item {\n\tdisplay: flex;\n\tgap: 2rem;\n}\n\n.room__item__column {\n\tdisplay: flex;\n\tflex-direction: column;\n\twidth: calc(50% - 1.88rem);\n\tgap: 2rem;\n}\n\n.room__item__column .services__items {\n\theight: 10rem;\n}\n\n.room__item img,\n.room__item__column img {\n\tcursor: pointer;\n}\n\n.info__block {\n\twidth: 100%;\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 1.5rem;\n}\n\n.info__header {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\twidth: 100%;\n}\n\n.room__name {\n\tcolor: var(--accent-color, #956446);\n\n\t/* H3 */\n\tfont-family: 'Noto Sans';\n\tfont-size: 1.625rem;\n\tfont-style: normal;\n\tfont-weight: 500;\n\tline-height: 150%; /* 2.4375rem */\n}\n\n.room__persons {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 1rem;\n\n\tcolor: var(--accent-color, #956446);\n\n\t/* text small */\n\tfont-family: 'Noto Sans';\n\tfont-size: 1rem;\n\tfont-style: normal;\n\tfont-weight: 400;\n\tline-height: 160%; /* 1.6rem */\n}\n\n.info__text {\n\twidth: 100%;\n\tcolor: var(--accent-color, #956446);\n\n\t/* text small */\n\tfont-family: 'Noto Sans';\n\tfont-size: 1rem;\n\tfont-style: normal;\n\tfont-weight: 400;\n\tline-height: 160%; /* 1.6rem */\n\theight: 3rem;\n}\n\n.info__services {\n\tcolor: var(--accent-color, #956446);\n\n\t/* text small bold */\n\tfont-family: 'Noto Sans';\n\tfont-size: 1rem;\n\tfont-style: normal;\n\tfont-weight: 700;\n\tline-height: 160%; /* 1.6rem */\n\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 1rem;\n}\n\n.services__items {\n\tdisplay: flex;\n\tflex-direction: column;\n\n\tgap: 0.5rem;\n}\n\n.service__item {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 0.65rem;\n\n\t/* text small */\n\tfont-family: 'Noto Sans';\n\tfont-size: 1rem;\n\tfont-style: normal;\n\tfont-weight: 400;\n\tline-height: 160%; /* 1.6rem */\n}\n.service__item svg {\n\twidth: 1.5625rem;\n\theight: 1.5625rem;\n}\n\n.info__footer {\n\tmargin-top: 2rem;\n\twidth: 100%;\n\tborder-top: 1px solid var(--accent-color);\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 1.25rem;\n}\n\n.info__price {\n\tmargin-top: 1.25rem;\n\tdisplay: flex;\n\tjustify-content: space-between;\n\n\tcolor: var(--accent-color, #956446);\n\tfont-size: 1rem;\n\tfont-style: normal;\n\tfont-weight: 600;\n\tline-height: 160%; /* 1.6rem */\n}\n\n.footer__buttons {\n\tdisplay: flex;\n\tgap: 1.25rem;\n}\n\n.primary__btn {\n\twidth: 13.4375rem;\n\theight: 3.125rem;\n\tflex-shrink: 0;\n\tborder-radius: 0.5rem;\n\tbackground: var(--accent-color, #956446);\n\n\t/* btn */\n\tbox-shadow: -2px 4px 5px 0px rgba(148, 93, 60, 0.06);\n\n\tcolor: var(--text-color, #fff);\n\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\n\t/* text small semibold */\n\tfont-family: 'Noto Sans';\n\tfont-size: 1rem;\n\tfont-style: normal;\n\tfont-weight: 600;\n\tline-height: 160%; /* 1.6rem */\n\n\tcursor: pointer;\n}\n\n.secondary__btn {\n\twidth: 13.4375rem;\n\theight: 3.125rem;\n\tflex-shrink: 0;\n\n\tborder-radius: 0.5rem;\n\tborder: 1px solid var(--accent-color, #956446);\n\tbackground: var(--text-color, #fff);\n\n\t/* btn light */\n\tbox-shadow: -2px 4px 5px -4px rgba(109, 95, 85, 0.08);\n\n\tcolor: var(--accent-color, #956446);\n\n\t/* text small semibold */\n\tfont-family: 'Noto Sans';\n\tfont-size: 1rem;\n\tfont-style: normal;\n\tfont-weight: 600;\n\tline-height: 160%; /* 1.6rem */\n\n\tcursor: pointer;\n}\n\n@media (max-width: 460px) {\n\t.room__item {\n\t\tflex-direction: column;\n\t\talign-items: center;\n\t\tbox-sizing: border-box;\n\t\twidth: 100%;\n\t}\n\n\t.room__item__column {\n\t\tflex-direction: column;\n\t\talign-items: center;\n\t\tbox-sizing: border-box;\n\t\twidth: 100%;\n\t}\n\n\t.room__item img {\n\t\twidth: 100%;\n\t}\n\n\t.info__text {\n\t\theight: auto;\n\t}\n\n\t.info__block {\n\t\theight: auto;\n\t\twidth: 100%;\n\t}\n\t.room__name {\n\t\tfont-size: 1.5rem;\n\t\tfont-style: normal;\n\t\tfont-weight: 500;\n\t\tline-height: 130%; /* 1.95rem */\n\t}\n\n\t.room__persons {\n\t\tfont-size: 0.9375rem;\n\t\tfont-style: normal;\n\t\tfont-weight: 400;\n\t\tline-height: 160%; /* 1.5rem */\n\t\tgap: 0.3rem;\n\t\twidth: 10rem;\n\t\tjustify-content: flex-end;\n\t}\n\t.footer__buttons {\n\t\tflex-direction: column;\n\t\tgap: 0.6rem;\n\t}\n\t.primary__btn {\n\t\twidth: 100%;\n\t}\n\t.secondary__btn {\n\t\twidth: 100%;\n\t}\n}\n\n@media (max-width: 360px) {\n\t.room__persons {\n\t\twidth: 12rem;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"room__item": `RoomItem_room__item__bmEq-`,
	"room__item__column": `RoomItem_room__item__column__zrvJj`,
	"services__items": `RoomItem_services__items__Lu01d`,
	"info__block": `RoomItem_info__block__KVhXn`,
	"info__header": `RoomItem_info__header__nxZJe`,
	"room__name": `RoomItem_room__name__ctW-D`,
	"room__persons": `RoomItem_room__persons__iO6d6`,
	"info__text": `RoomItem_info__text__g5zMs`,
	"info__services": `RoomItem_info__services__pGA3F`,
	"service__item": `RoomItem_service__item__-mpJv`,
	"info__footer": `RoomItem_info__footer__sU60I`,
	"info__price": `RoomItem_info__price__wRkhh`,
	"footer__buttons": `RoomItem_footer__buttons__T2j4c`,
	"primary__btn": `RoomItem_primary__btn__2hhw7`,
	"secondary__btn": `RoomItem_secondary__btn__cEmVe`
};
export default ___CSS_LOADER_EXPORT___;
